"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportProducts = exportProducts;
exports.mutateProducts = mutateProducts;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var INBOUNDDB_EXPORT_URL = 'inbounddb-io/exports';
var INBOUNDDB_PRODUCT_MUTATION_URL = 'inbounddb-objects/v1/batch-mutation/PRODUCT';

function exportProducts(data) {
  return _apiClient.default.post(INBOUNDDB_EXPORT_URL, {
    data: data
  });
}

function mutateProducts(data) {
  var type = data.type,
      expectedNumberObjectsModified = data.expectedNumberObjectsModified,
      _data$contactsSearch = data.contactsSearch,
      search = _data$contactsSearch.search,
      sorts = _data$contactsSearch.sorts,
      offset = _data$contactsSearch.offset,
      filterGroups = _data$contactsSearch.filterGroups;
  return _apiClient.default.post(INBOUNDDB_PRODUCT_MUTATION_URL, {
    data: {
      type: type,
      applyToAll: true,
      objectType: 'PRODUCT',
      expectedNumberObjectsModified: expectedNumberObjectsModified,
      contactsSearch: {
        offset: offset,
        query: search,
        count: 100,
        sorts: sorts.toJS(),
        filterGroups: filterGroups.toJS()
      }
    }
  });
}